module.exports = __webpack_public_path__ + "static/media/paypal.51aeb546.png";